module.exports = __webpack_public_path__ + "assets/img/separator_icon.94055040.svg";